<template>
	<Toast position="bottom-center">
		<!-- Remove close button -->
		<template #closeicon>
			<span />
		</template>

		<!-- Make custom message slot to make close on tap -->
		<template #message="props">
			<div class="d-flex w-100" style="font-weight: 500; cursor: pointer;" @click="toast.remove(props.message)">
				<div class="mr-2 text-center" style="min-width: 30px; align-self: center;">
					<font-awesome-icon v-if="props.message.severity=='success'" icon="fa-solid fa-check" size="2x" />
					<font-awesome-icon v-if="props.message.severity=='info'" icon="fa-solid fa-info" size="2x" />
					<font-awesome-icon v-if="props.message.severity=='error'" icon="fa-solid fa-exclamation" size="2x" />
					<font-awesome-icon v-if="props.message.severity=='warn'" icon="fa-solid fa-exclamation" size="2x" />
				</div>

				<div style="align-self: center;">
					{{ props.message.summary }}
				</div>
			</div>
		</template>
	</Toast>
</template>

<script setup>
import { useToast } from 'primevue';

const toast = useToast()
</script>

<style lang="scss">
body{
	// Hide close button completely
	.p-toast-close-button{
		display: none;
	}

	--p-toast-border-width: 0;
	--p-toast-summary-font-size: 15px;
	--p-toast-content-padding: 1rem;
	--p-toast-summary-font-weight: bold;

	--p-toast-info-shadow: 0 0 12px #999;
	--p-toast-success-shadow: 0 0 12px #999;
	--p-toast-warn-shadow: 0 0 12px #999;
	--p-toast-error-shadow: 0 0 12px #999;
	--p-toast-secondary-shadow: 0 0 12px #999;

	// Dark mode
	[data-theme="dark"] &{
		--p-toast-info-shadow: 0px 4px 8px 0px #00000099;
		--p-toast-success-shadow: 0px 4px 8px 0px #00000099;
		--p-toast-warn-shadow: 0px 4px 8px 0px #00000099;
		--p-toast-error-shadow: 0px 4px 8px 0px #00000099;
		--p-toast-secondary-shadow: 0px 4px 8px 0px #00000099;

		--p-toast-info-color: white;
		--p-toast-success-color: white;
		--p-toast-warn-color: white;
		--p-toast-error-color: white;
		--p-toast-secondary-color: white;

		--p-toast-info-background: var(--default-background-color);
		--p-toast-success-background: var(--default-background-color);
		--p-toast-warn-background: var(--default-background-color);
		--p-toast-error-background: var(--default-background-color);
		--p-toast-secondary-background: var(--default-background-color);
	}
}
</style>